import MainSharedComponent from "@components/severalbrands/ourStoryPage/mainSharedComponent";
const info = {
    img: "/severalbrands/assets/images/downloadPdf2.png",
    mainTitle:
        "10 Key Considerations Before Partnering With a Lead Generation Company",
    paragraphs: [
        "Curious about lead generation companies and whether they're worth the investment? Read our guide to learn how they work, what to consider before working with them, and the benefits they can provide for your business.",
    ],
    mainSectionClassName: `3xl:gap-[150px] lg:gap-[90px] gap-[45px] `,
    mainTitleClassName: "text-[#351C4F]",
    imgClassName:
        "w-[220px]  h-[200px] md:w-[603px] md:min-w-[603px] md:h-[554px] 3xl:w-[803px] 3xl:min-w-[803px] 3xl:h-[754px] relative ",
    showButton: true,
    secondSectionClassName: "lg:mt-[80px]",
    mainH1Element: true,
};

export default function FirstSection() {
    return (
        <section className="lg:mb-32 mb-20 px-4 lg:px-0 mt-20 lg:mt-0">
            <MainSharedComponent info={info} />
        </section>
    );
}
